<template>
  <div id="mfv">
    <div class="page">
      <RouterView />
    </div>
    <Popup />
    <Loader />
  </div>
</template>

<script>
import moment from 'moment'
import PubSub from '@helper/PubSub'
import Vue from 'vue'
import Popup from '@cmp/Popup'
import Loader from '@cmp/Loader'

export default {
  name: 'App',
  components: {
    Popup,
    Loader,
  },
  created() {
    window.addEventListener('keyup', (event) => {
      this.keyupHandler(event)
    })

    window.addEventListener('click', (_event) => {
      PubSub.publish('body-clicked')
    })

    this.checkMaxStorePeriod()
  },
  methods: {
    keyupHandler(event) {
      if (event.keyCode === Vue.config.keyCodes.esc) {
        PubSub.publish('key-ESC')
      }
    },
    checkMaxStorePeriod() {
      const sixtyDaysAgo = moment().subtract(60, 'days').format('YYYY-MM-DD')
      const { lastVisit } = this.$store.state
      const shouldResetStore = moment(lastVisit).isSameOrBefore(sixtyDaysAgo)

      if (shouldResetStore) {
        this.$store.commit('resetNewContractState')
      }

      // update last visit to current date
      this.$store.commit('SET_LASTVISIT', moment().format('YYYY-MM-DD'))
    },
  },
}

</script>

<style lang="scss">
  @import "../../stylesheets/base.scss";
</style>
